export const getParallelByGradeName = (name: string): string => (
  name.trim().slice(0, 2).trim()
);
